// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container__2o6LS","choose":"styles__choose__3KIUO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductFooter/styles.scss
// module id = 407
// module chunks = 0